module.exports = __webpack_public_path__ + "img/gem-found-purple.f6c2aa68.png";